import HeaderContentsWithNoNavigation from '../../components/organism/headers/HeaderContentsWithNoNavigation'
export default {
  components: { HeaderContentsWithNoNavigation }
}
